import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import { HorizontalScroll } from "../horizontal-scroll";
import ProductCard from "../ProductCard";
import { Icon } from "../Icon";

type Props = {
  sections: CarouselExtended;
};

const HomeCatalogMobile: FunctionComponent<Props> = ({ sections }) => {
  const navigate = useNavigate();

  const categorie = (categorie: string) => {
    switch (categorie.toLowerCase()) {
      case "brazalete":
        return "Pulseras";
      case "chain":
        return "Cadenas";
      case "ring":
        return "Anillos";
      case "pendant":
        return "Dijes";
      case "hoop":
        return "Aros";
      case "finding":
        return "Fornituras";
      default:
        return "Accesorios";
    }
  };

  const translation = (categorie: string) => {
    if (
      categorie.toLocaleLowerCase() === "brazalete" ||
      categorie.toLocaleLowerCase() === "chain"
    )
      return "todas las";
    else return "todos los";
  };

  return (
    <section className="catalog_mobile_container">
      <section key={sections.name} className="catalog_mobile_categories">
        <div className="category_type_container">
          <div className="category_type">
            <p className="category_name">{categorie(sections.name)}</p>
            <p className="category_description">En oro 18k y plata 925.</p>
          </div>
        </div>
        <HorizontalScroll
          scrollBy={293}
          catalogScroll={true}
          items={sections.products.length}
        >
          <div className="category_scroll_mobile">
            {sections.products.length > 0 &&
              sections.products.map((p) => {
                return (
                  <ProductCard
                    title={p.productId?.title}
                    key={p.productId?._id}
                    img={p.productId?.thumbnailUrl}
                    friendlyUrl={p.productId?.friendlyUrl}
                    sku={p.productId?.sku}
                  />
                );
              })}
          </div>
        </HorizontalScroll>
        <div className="categorie_view_all_container">
          <button
            className="categorie_view_all"
            onClick={() => navigate(`/category/${sections.name.toLowerCase()}`)}
          >
            Ver {translation(sections.name).toLowerCase()}{" "}
            {categorie(sections.name).toLowerCase()}
          </button>
        </div>
      </section>
    </section>
  );
};

export default HomeCatalogMobile;
